function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.5002 12.3578C17.7962 12.5428 16.7692 12.7468 15.6542 12.7468C14.5132 12.7468 13.5092 12.5338 12.6712 12.1148C11.4122 11.4858 9.95724 11.1668 8.34624 11.1668C7.29024 11.1668 6.30624 11.3058 5.50024 11.4738V3.88876C6.20424 3.70376 7.23124 3.49976 8.34624 3.49976C9.48724 3.49976 10.4912 3.71176 11.3292 4.13176C12.5882 4.76076 14.0432 5.07976 15.6542 5.07976C16.7102 5.07976 17.6952 4.94076 18.5002 4.77276V12.3578ZM15.6542 3.57976C14.4692 3.57976 13.1852 3.38276 12.0002 2.78976C10.8152 2.19676 9.53124 1.99976 8.34624 1.99976C5.97624 1.99976 4.00024 2.78976 4.00024 2.78976V4.99676V21.2468C4.00024 21.6608 4.33524 21.9968 4.75024 21.9968C5.16424 21.9968 5.50024 21.6608 5.50024 21.2468V13.0128C6.26824 12.8338 7.26024 12.6668 8.34624 12.6668C9.53124 12.6668 10.8152 12.8638 12.0002 13.4568C13.1862 14.0488 14.4692 14.2468 15.6542 14.2468C18.0242 14.2468 20.0002 13.4568 20.0002 13.4568V2.78976C20.0002 2.78976 18.0252 3.57976 15.6542 3.57976Z",
  fill: "#7F7F7F"
});

function SvgIconFlagLinear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlagLinear);
export default __webpack_public_path__ + "static/media/iconFlagLinear.cc2d1fc2.svg";
export { ForwardRef as ReactComponent };